import { useNavigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { MessageCircle, Clock, LayoutDashboard } from "lucide-react";

const STEPS = [
  ["🌐", "Create account from abroad", "No India mobile number required."],
  ["📋", "Add your parent's care profile", "Address, health notes, ABHA ID (optional)."],
  ["👤", "Browse & book a verified carer", "In Hyderabad or Bengaluru."],
  ["💳", "Pay in your currency", "USD, GBP, AED, SGD via international card."],
  ["📱", "Track every visit", "WhatsApp updates, photos, care notes in your timezone."],
];

export default function NRI() {
  const nav = useNavigate();
  return (
    <PublicLayout>
      <section style={{ background: "linear-gradient(120deg,var(--butter-soft),var(--coral-soft))" }}>
        <div className="bmc-wrap py-16">
          <h1 className="text-4xl sm:text-5xl font-extrabold">Care for your parents in India — from anywhere.</h1>
          <p className="text-lg text-ink-soft mt-4 max-w-2xl">Distance doesn't mean being in the dark. Book, pay and track verified care for your family back home.</p>
          <div className="text-5xl md:text-6xl mt-6 tracking-widest">🇺🇸 🇬🇧 🇦🇪 🇸🇬 🇦🇺</div>
        </div>
      </section>

      <section className="bmc-wrap py-16">
        <div className="grid md:grid-cols-5 gap-4">
          {STEPS.map(([icon, t, d], i) => (
            <div key={t} className="card-bmc p-5"><span className="text-3xl">{icon}</span><p className="text-xs font-bold text-coral mt-3">STEP {i + 1}</p><h3 className="font-display font-bold mt-1 text-[15px]">{t}</h3><p className="text-sm text-ink-soft mt-2">{d}</p></div>
          ))}
        </div>
      </section>

      <section className="bg-ivory-2 py-16">
        <div className="bmc-wrap">
          <h2 className="text-3xl font-bold">What you get</h2>
          <div className="grid md:grid-cols-3 gap-4 mt-8">
            {[[MessageCircle, "Daily WhatsApp updates", "A check-in message, photo and care note after every visit."], [Clock, "Timezone-aware support", "Customer support across IST, EST, GMT and GST."], [LayoutDashboard, "Family portal", "Bookings, payments, care logs and carer ratings in one place."]].map(([I, t, d]) => (
              <div key={t} className="card-bmc p-6"><I size={26} className="text-coral" /><h3 className="font-display font-bold mt-3">{t}</h3><p className="text-sm text-ink-soft mt-2">{d}</p></div>
            ))}
          </div>
        </div>
      </section>

      <section className="bmc-wrap py-16">
        <div className="grid md:grid-cols-3 gap-4">
          {["UPI (NRIs with NRE accounts)", "International credit/debit card via Razorpay", "Wire transfer / NRE/NRO account"].map((t) => (
            <div key={t} className="card-bmc p-6 text-center font-semibold">{t}</div>
          ))}
        </div>
        <div className="bg-ink text-ivory rounded-r-lg p-10 mt-10">
          <p className="text-xl text-ivory italic leading-relaxed">"I was in New Jersey, worried sick about my father in Hyderabad after his hip surgery. BookMyCarer found us a brilliant physiotherapist within two hours. I get WhatsApp updates every evening. I feel like I'm actually there."</p>
          <p className="text-butter font-semibold mt-4">— Anita P., New Jersey 🇺🇸 · ★★★★★</p>
        </div>
        <div className="text-center mt-10 flex flex-wrap gap-3 justify-center">
          <button onClick={() => nav("/register")} className="btn-pill bg-coral text-white px-6 py-3" data-testid="nri-setup">Set up NRI care</button>
          <a href="https://wa.me/919000000000?text=Hi+BookMyCarer" target="_blank" rel="noreferrer" className="btn-pill bg-[#25D366] text-white px-6 py-3"><MessageCircle size={16} /> Talk to our NRI team</a>
        </div>
      </section>
    </PublicLayout>
  );
}
